import http from '@/utils/request';
//获取消息中心分类
export function getMessageTypeList(query) {
  return http.request({
    url: '/system/message/type/restful/list',
    method: 'get',
    params: { ...query, ...{ usePlatform: 'portal' } },
  });
}
//获取消息中心消息列表
export function getMessageList(query, isInner) {
  return http.request({
    url: '/system/msgSend/listForUser',
    method: 'get',
    params: { ...query, ...{ usePlatform: isInner ? 'portal' : 'restPortal' } },
  });
}
//获取消息中心未读数量
export function getUnReadCount(isInner) {
  return http.request({
    url: '/system/msgSend/getUnReadCount',
    method: 'get',
    params: { usePlatform: isInner ? 'portal' : 'restPortal' },
  });
}
//设置消息为已读
export function readMsg(query) {
  return http.request({
    url: '/system/msgSend/readMsg',
    method: 'put',
    params: query,
  });
}
//全部已读
export function readAllMsg(query) {
  return http.request({
    url: '/system/msgSend/readAllMsg',
    method: 'put',
    params: { ...query, ...{ usePlatform: 'portal' } },
  });
}
